import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { TrackingLink } from "../../store/admin/trackingLinksStore";

export interface TrackingLinkListParams {
  page?: number;
  limit?: number;
  accessType?: string;
  status?: string;
  search?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface TrackingLinkListBody {
  data?: TrackingLink[];
  meta?: ListMeta;
}

export interface TrackingLinkListResult {
  data: TrackingLink[];
  meta?: ListMeta;
}

export function useTrackingLinksList(params: TrackingLinkListParams = {}) {
  const cid = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.trackingLinks.list(cid, params),
    queryFn: ({ signal }) =>
      getJson<TrackingLinkListBody>(
        "/trackingLinks",
        { page: 1, limit: 6, ...params },
        { signal },
      ).then((body) => ({ data: body.data ?? [], meta: body.meta })),
  });
}
